import { createSlice } from '@reduxjs/toolkit';

import { RootState } from 'store';
import { fetchCurrentYearRequests, fetchRequests } from 'services';

import { RequestsState } from './types';

const initialState: RequestsState = {
  compensations: [],
  count: 0,
  filters: {},
  isCurrentYearLoading: false,
};

const requestsSlice = createSlice({
  name: 'requests',
  initialState,
  reducers: {
    setRequestsFilters(state: RequestsState, { payload }: { payload: RequestsState['filters'] }) {
      state.filters = {
        ...state.filters,
        ...payload,
      };
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchRequests.fulfilled, (state, { payload }) => {
        state.compensations = payload;
      })
      .addCase(fetchCurrentYearRequests.pending, (state) => {
        state.isCurrentYearLoading = true;
      })
      .addCase(fetchCurrentYearRequests.fulfilled, (state, { payload }) => {
        state.compensations = payload;
        state.isCurrentYearLoading = false;
      })
      .addCase(fetchCurrentYearRequests.rejected, (state) => {
        state.isCurrentYearLoading = false;
      });
  },
});

export const {
  reducer: requestsReducer,
  actions: { setRequestsFilters },
} = requestsSlice;

export const getAllCompensations = ({ requests }: RootState) => requests.compensations;
export const getRequestsFilters = ({ requests }: RootState) => requests.filters;
export const getRequestsIsCurrentYearLoading = ({ requests }: RootState) => requests.isCurrentYearLoading;
